import { render, staticRenderFns } from "./SmoothReflow.vue?vue&type=template&id=517d9a00&scoped=true"
import script from "./SmoothReflow.vue?vue&type=script&lang=ts"
export * from "./SmoothReflow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d9a00",
  null
  
)

export default component.exports